import React, { Component } from "react";
import PropTypes from "prop-types";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import App from "./App";
import ReactGA from "react-ga";

export default class Root extends Component {
  componentDidMount() {
    const isProd =
      window.location.hostname === "www.bio-rad.com" ? true : false;
    ReactGA.initialize("UA-145421575-2", {
      testMode: !isProd
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object
};
